export default {
  'error.csrf_reload_required':
    'Deze pagina is niet meer geldig. Laad de pagina opnieuw en probeer het nog een keer.',
  'error.too_many_requests': 'Te veel aanvragen. Probeer het later nog eens.',
  'page_reset_password.title': 'Wachtwoord Resetten',
  'page_reset_password.description':
    'Voer je nieuwe wachtwoord in om het te resetten',
  'page_reset_password.form_password': 'Wachtwoord',
  'page_reset_password.form_password_confirmation': 'Wachtwoord bevestiging',
  'page_reset_password.toast_successful_title':
    'Je wachtwoord is succesvol gereset.',
  'page_reset_password.toast_successful_description': 'Je kunt nu inloggen.',
  'page_reset_password.form_schema_min_1_password': 'Wachtwoord is verplicht',
  'page_reset_password.form_schema_min_8_password':
    'Wachtwoord moet minimaal 8 tekens lang zijn',
  'page_reset_password.form_schema_strong_password':
    'Wachtwoord niet sterk genoeg',
  'page_reset_password.form_schema_match_password':
    'Wachtwoorden komen niet overeen.',
  'page_setup_password.title': 'Wachtwoord Instellen',
  'page_setup_password.description': 'Maak je nieuwe wachtwoord aan',
  'page_setup_password.form_password': 'Wachtwoord',
  'page_setup_password.form_current_password': 'Tijdelijk wachtwoord',
  'page_setup_password.form_password_confirmation': 'Wachtwoord bevestiging',
  'page_setup_password.form_email': 'E-mailadres',
  'page_setup_password.toast_successful_title':
    'Je wachtwoord is succesvol ingesteld.',
  'page_setup_password.toast_successful_description':
    'Je kunt nu beginnen met het gebruiken van de portal.',
  'page_setup_password.submitting': 'Bezig met verwerken...',
  'page_setup_password.server_error':
    'Wachtwoord instellen mislukt. Probeer het opnieuw.',
  'page_setup_password.form_schema_min_1_password': 'Wachtwoord is verplicht',
  'page_setup_password.form_schema_min_8_password':
    'Wachtwoord moet minimaal 8 tekens lang zijn',
  'page_setup_password.form_schema_strong_password':
    'Wachtwoord niet sterk genoeg',
  'page_setup_password.form_schema_match_password':
    'Wachtwoorden komen niet overeen.',
  'page_change_password.title': 'Wachtwoord Wijzigen',
  'page_set_password.title': 'Wachtwoord Instellen',
  'page_change_password.description': 'Hier wijzig je je wachtwoord',
  'page_set_password.description': 'Hier stel je je wachtwoord in',
  'page_change_password.form_current_password': 'Huidig Wachtwoord',
  'page_change_password.form_new_password': 'Nieuw Wachtwoord',
  'page_change_password.form_new_password_confirmation':
    'Nieuw Wachtwoord Bevestigen',
  'page_change_password.error.current_password_invalid':
    'Het oude wachtwoord is onjuist.',
  'page_change_password.error.required_field': 'Vul het veld {{field}} in.',
  'page_change_password.error.required': 'Vul de verplichte velden in.',
  'page_change_password.error.confirmed':
    'De bevestiging van het nieuwe wachtwoord komt niet overeen.',
  'page_change_password.error.new_password_min':
    'Het nieuwe wachtwoord is te kort.',
  'page_change_password.error.validation':
    'Controleer de ingevulde wachtwoordvelden.',
  'page_change_password.error.generic': 'Wachtwoord wijzigen mislukt.',
  'page_change_password.toast_successful_title':
    'Je wachtwoord is succesvol gewijzigd.',
  'page_set_password.toast_successful_title':
    'Je wachtwoord is succesvol ingesteld.',
  'page_email_notification.title': 'Email Notificaties',
  'page_email_notification.new_bookings': 'Nieuwe Boekingen',
  'page_email_notification.booking_updates': 'Boeking Updates',
  'page_email_notification.toast_successful_title':
    'Notificaties succesvol bijgewerkt.',
  'page_credit.title': 'Credit',
  'page_credit.description':
    'Koop credits om meer vacatures aan te maken en meer kandidaten te bereiken.',
  'page_credit.form_credit': 'Credit Bedrag',
  'page_credit.placeholder': 'Voer een credit bedrag in',
  'page_credit.form_schema_required_credit': 'Credit bedrag is verplicht',
  'page_credit.form_schema_numeric_credit':
    'Credit bedrag moet een nummer zijn',
  'page_credit.form_schema_min_1_credit': 'Credit bedrag moet minimaal 1 zijn',
  'button.purchase': 'Kopen',
  'button.purchasing': 'Kopen...',
  'page_credit.current_credits': 'Huidige credits',
  'page_credit.total': 'Totaal',
  'page_credit.choose_amount_below': 'Kies je bedrag hieronder.',
  'page_users_overview.title': 'Klanten',
  'page_reports_overview.title': 'Rapporten',
  'page_reports_overview.id': 'ID',
  'page_reports_overview.connect_id': 'Verbindings-ID',
  'page_reports_overview.customer': 'Klanten',
  'page_reports_overview.email': 'E-mail',
  'page_reports_overview.report_name': 'Rapportnaam',
  'page_reports_overview.period': 'Periode',
  'page_reports_overview.progress': 'Voortgang',
  'page_reports_overview.status': 'Status',
  'page_reports_overview.status_in_progress': 'Bezig',
  'page_reports_overview.status_completed': 'Voltooid',
  'page_reports_overview.trigger_type': 'Trigger Type',
  'page_reports_overview.triggered_at': 'Getriggerd Op',
  'page_reports_overview.export': 'Genereer Rapporten',
  'page_reports_overview.export_reports': 'Rapporten exporteren',
  'page_reports_overview.export_report_tooltip': 'Rapporten exporteren',
  'page_reports_overview.actions': 'Acties',
  'page_reports_overview.export_title_popup': 'Rapporten genereren',
  'page_reports_overview.export_description_popup':
    'Vul de begin- en einddatum in en geef de rapporten een naam.',
  'page_reports_overview.export_warning_message':
    'Let op: bij deze actie worden de door de klant ingevulde Geladen kWhs en Opname datums gereset!',
  'page_reports_overview.export_reports_title_popup': 'Rapporten exporteren',
  'page_reports_overview.export_reports_description_popup':
    'Selecteer de naam van de rapporten.',
  'page_reports_overview.export_current_report_title_popup':
    'Geselecteerde rapporten exporteren',
  'page_reports_overview.export_current_report_description_popup':
    'Bevestig dat je de geselecteerde rapporten wilt exporteren.',
  'page_reports_overview.export_current_report_label':
    'Geselecteerde rapporten',
  'page_reports_overview.export_current_report_submit': 'Rapporten exporteren',
  'page_reports_overview.export_current_report_disabled_tooltip':
    'Deze rapporten worden nog gegenereerd en kunnen nu nog niet worden geëxporteerd. Wacht tot de batch is voltooid.',
  'page_reports_overview.export_reports_placeholder': 'Selecteer rapporten',
  'page_reports_overview.export_reports_search_placeholder':
    'Typ om snel rapporten te zoeken...',
  'page_reports_overview.export_reports_required': 'Selecteer rapporten.',
  'page_reports_overview.export_reports_loading': 'Rapporten laden...',
  'page_reports_overview.export_reports_empty':
    'Er zijn geen rapporten beschikbaar om te exporteren.',
  'page_reports_overview.export_report_name_label': 'Rapportnaam',
  'page_reports_overview.export_report_name_placeholder': 'Voer rapportnaam in',
  'page_reports_overview.export_report_name_helper':
    'Maximaal 50 tekens en gebruik een unieke naam.',
  'page_reports_overview.export_report_name_required':
    'Rapportnaam is verplicht.',
  'page_reports_overview.export_report_name_too_long':
    'Rapportnaam mag maximaal 50 tekens bevatten.',
  'page_reports_overview.export_report_name_checking':
    'Rapportnaam controleren...',
  'page_reports_overview.export_report_name_exists':
    'Deze rapportnaam bestaat al.',
  'page_reports_overview.export_report_name_available':
    'Deze rapportnaam is beschikbaar.',
  'page_reports_overview.export_from_label': 'Begin datum',
  'page_reports_overview.export_to_label': 'Eind datum',
  'page_reports_overview.export_date_placeholder': 'Selecteer datum',
  'page_reports_overview.export_from_required': 'Begindatum is verplicht.',
  'page_reports_overview.export_to_required': 'Einddatum is verplicht.',
  'page_reports_overview.export_to_after_from':
    'Einddatum moet gelijk zijn aan of later zijn dan de begindatum.',
  'page_reports_overview.export_date_future':
    'Datums in de toekomst zijn niet toegestaan.',
  'page_reports_overview.delete_title_popup':
    'Weet je zeker dat je dit rapport wilt verwijderen?',
  'page_reports_overview.delete_description_popup':
    'Deze actie is onomkeerbaar.',
  'page_reports_overview.deleted_success': 'Rapport is verwijderd.',
  'page_report_show.title': 'Rapportdetails',
  'page_report_show.info_card_title': 'Rapportinformatie',
  'page_report_show.report_start_date': 'Rapport begindatum',
  'page_report_show.report_end_date': 'Rapport einddatum',
  'page_report_show.registration_date': 'Opnamedatum',
  'page_user_overview.delete_user': 'Klant Verwijderen',
  'page_user_overview.delete_user_title_popup':
    'Weet je zeker dat je deze klant wilt verwijderen?',
  'page_user_overview.delete_user_description_popup':
    'Deze actie is onomkeerbaar.',
  'page_user_overview.delete_user_successful_title_popup':
    'Klant is verwijderd.',
  'page_user_show.show_user_title': 'Klant Bekijken',
  'page_user_show.reset_password_button': 'Wachtwoord resetten',
  'page_user_show.form_last_login': 'Laatste Login',
  'page_user_show.user_language': 'Weergavetaal van de klanten',
  'page_user_show.form_verify_email': 'Email Status',
  'page_user_show.info_card_title': 'Klantinformatie',
  'page_user_show.info_group_card_title': 'Groep Informatie',
  'page_user_show.role_card_title': 'Klant Rol',
  'page_user_show.form_created_at': 'Opnamedatum',
  'page_user_show.form_updated_at': 'Bijgewerkt Op',
  'page_user_edit.edit_user_title': 'Klant Bewerken',
  'page_user_edit.form_status': 'Status',
  'page_user_edit.edit_title_popup': 'Klant succesvol bijgewerkt.',
  'page_user_edit.form_language': 'Weergavetaal',
  'page_user_edit.external_user': 'Externe klanten',
  'page_user_edit.internal_user': 'Interne klanten',
  'page_user_edit.form_user_type': 'Type klanten',
  'page_user_edit.delete_employer': 'Account verwijderen',
  'page_user_edit.delete_customer': 'Account verwijderen',
  'page_user_edit.by_deleting_account':
    'Door dit account te verwijderen, worden al je persoonlijke informatie en vacaturegegevens permanent verwijderd en kunnen niet worden hersteld.',
  'page_user_edit.you_will_not_create_account':
    'Je zult geen nieuw account kunnen aanmaken met het emailadres ',
  'page_user_edit.delete_page_title_popup':
    'Weet je zeker dat je dit wilt doen?',
  'page_user_create.create_user_title': 'Klant aanmaken',
  'page_user_create.create_user_card_information_title': 'Klantinformatie',
  'page_user_create.create_user_card_group information_title':
    'Groep Informatie',
  'page_user_create.create_user_card_membership_information_title':
    'Lidmaatschap Informatie',
  'page_user_create.created_title_popup': 'Klant succesvol aangemaakt.',
  'page_user_create.created_description_popup':
    'Er is een email verzonden voor het instellen van het wachtwoord.',
  'page_user_create.form_email': 'Email',
  'page_user_create.credit': 'Credit',
  'page_user_create.form_first_name': 'Voornaam',
  'page_user_create.form_last_name': 'Achternaam',
  'page_user_create.form_status': 'Account Status',
  'page_user_create.company': 'Bedrijf',
  'page_user_overview.full_name_user_title_table': 'Volledige Naam',
  'page_user_create.form_information': 'Informatie',
  'page_user_create.form_phone_number': 'Telefoonnummer',
  'page_user_create.form_role': 'Rol',
  'page_user_create.form_select_role': 'Selecteer Rol',
  'page_user_create.form_schema_min_email': 'Voer email in',
  'page_user_create.form_schema_max_email':
    'Email mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_invalid_email': 'Ongeldig emailadres',
  'page_user_create.form_schema_gender': 'Selecteer Geslacht',
  'page_user_create.form_schema_min_first_name': 'Voer Voornaam in',
  'page_user_create.form_schema_min_group_name': 'Voer Groepsnaam in',
  'page_user_create.form_schema_min_password':
    'Wachtwoord moet minimaal 8 tekens zijn',
  'page_user_create.form_schema_max_password': 'Wachtwoord maximaal 64 tekens',
  'page_user_create.form_schema_max_first_name':
    'Voornaam mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_min_last_name': 'Voer Achternaam in',
  'page_user_create.form_schema_max_last_name':
    'Achternaam mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_max_contact_first_name':
    'Contact voornaam mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_max_contact_last_name':
    'Contact achternaam mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_max_contact_email':
    'Contact email mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_max_billing_address':
    'Factuuradres mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_max_city':
    'Plaats mag niet langer dan 256 tekens zijn.',
  'page_user_create.form_schema_invalid_phone': 'Ongeldig telefoonnummer',
  'page_user_create.form_schema_role': 'Selecteer Rol',
  'page_user_create.form_schema_group_type': 'Groepstype',
  'page_user_create.form_schema_group_name': 'Groepsnaam',
  'page_user_create.form_schema_country_code': 'Landcode',
  'page_user_create.form_schema_company': 'Bedrijf',
  'page_user_create.form_schema_street_line_1': 'Straat 1',
  'page_user_create.form_schema_street_line_2': 'Straat 2',
  'page_user_create.form_schema_postal_code': 'Postcode',
  'page_user_create.form_schema_state': 'Provincie',
  'page_user_create.form_schema_phone': 'Telefoon',
  'page_user_create.form_contact_first_name': 'Contact Voornaam',
  'page_user_create.form_contact_last_name': 'Contact Achternaam',
  'page_user_create.form_contact_email': 'Contact Email',
  'page_user_create.form_billing_address': 'Factuuradres',
  'page_user_create.form_street_line_1': 'Straat 1',
  'page_user_create.form_street_line_2': 'Straat 2',
  'page_user_create.status': 'Status',
  'page_user_create.form_schema_end_at': 'Verloopdatum',
  'page_user_create.form_city': 'Plaats',
  'page_user_create.form_schema_group_type_placeholder': 'Selecteer groepstype',
  'page_user_create.form_schema_country_code_placeholder': 'Selecteer landcode',
  'page_user_create.form_schema_company_placeholder': 'Selecteer bedrijf',
  'page_user_create.form_schema_postal_code_placeholder': 'Selecteer postcode',
  'page_user_create.form_schema_state_placeholder': 'Selecteer provincie',
  'page_user_create.form_schema_group_type_validation': 'Selecteer Groepstype',
  'page_user_create.form_schema_membership_type': 'Type',
  'page_user_create.form_schema_membership_type_placeholder':
    'Selecteer Lidmaatschap',
  'page_admin_user_overview.users_title': 'Admins',
  'page_admin_user_overview.delete_user': 'Admin Verwijderen',
  'page_admin_user_overview.delete_user_title_popup':
    'Weet je zeker dat je deze portal gebruiker wilt verwijderen?',
  'page_admin_user_overview.delete_user_description_popup':
    'Deze actie is onomkeerbaar.',
  'page_admin_user_overview.delete_user_successful_title_popup':
    'Admin is verwijderd.',
  'page_admin_user_show.show_user_title': 'Admin Bekijken',
  'page_admin_user_show.reset_password_button': 'Wachtwoord resetten',
  'page_admin_user_show.form_last_login': 'Laatste Login',
  'page_admin_user_show.form_created_at': 'Aangemaakt Op',
  'page_admin_user_show.form_updated_at': 'Bijgewerkt Op',
  'page_admin_user_show.info_card_title': 'Admin Informatie',
  'page_admin_user_show.role_card_title': 'Admin Rol',
  'page_admin_user_edit.edit_user_title': 'Admin Bewerken',
  'page_admin_user_edit.form_status': 'Status',
  'page_admin_user_edit.edit_title_popup': 'Admin succesvol bijgewerkt.',
  'page_admin_user_edit.profile_title_popup': 'Profiel succesvol bijgewerkt.',
  'page_admin_user_create.create_user_title': 'Admin Aanmaken',
  'page_admin_user_create.created_title_popup': 'Admin succesvol aangemaakt.',
  'page_admin_user_create.created_description_popup':
    'Er is een email verzonden voor het instellen van het wachtwoord.',
  'page_admin_user_create.form_email': 'Email',
  'page_admin_user_create.form_first_name': 'Voornaam',
  'page_admin_user_create.form_last_name': 'Achternaam',
  'page_admin_user_create.form_phone_number': 'Telefoonnummer',
  'page_admin_user_create.form_role': 'Rol',
  'page_admin_user_create.form_select_role': 'Selecteer Rol',
  'page_admin_user_create.form_schema_min_email': 'Voer email in',
  'page_admin_user_create.form_schema_max_email':
    'Email mag niet langer dan 256 tekens zijn.',
  'page_admin_user_create.form_schema_invalid_email': 'Ongeldig emailadres',
  'page_admin_user_create.form_schema_min_first_name': 'Voer Voornaam in',
  'page_admin_user_create.form_schema_max_first_name':
    'Voornaam mag niet langer dan 256 tekens zijn.',
  'page_admin_user_create.form_schema_min_last_name': 'Voer Achternaam in',
  'page_admin_user_create.form_schema_max_last_name':
    'Achternaam mag niet langer dan 256 tekens zijn.',
  'page_admin_user_create.form_schema_invalid_phone': 'Ongeldig telefoonnummer',
  'page_admin_user_create.form_schema_role': 'Selecteer Rol',
  'page_admin_user_create.form_schema_company': 'Selecteer Bedrijf',
  'page_contact_create.form_gender': 'Geslacht',
  'page_contact_create.form_select_gender': 'Selecteer Geslacht',
  'page_user_create.form_schema_max_pin_code':
    'Pincode mag niet langer dan 4 tekens zijn.',
  'page_role_overview.roles_title': 'Admin Rollen',
  'page_role_overview.create_role_button': 'Aanmaken',
  'page_role_overview.edit_role_actions': 'Portal Rol Bewerken',
  'page_role_overview.delete_role_actions': 'Portal Rol Verwijderen',
  'page_role_overview.role_id_table': 'Rol ID',
  'page_role_overview.role_name_table': 'Rolnaam',
  'page_role_overview.permissions_table': 'Machtigingen',
  'page_role_overview.last_update_table': 'Laatste Update',
  'page_role_overview.delete_role_successful_title_popup': 'Rol is verwijderd.',
  'page_role_overview.delete_role_title_popup':
    'Weet je zeker dat je deze rol wilt verwijderen?',
  'page_role_overview.delete_role_description_popup':
    'Deze actie is onomkeerbaar.',
  'page_role_create.create_role_title': 'Portal Rol Aanmaken',
  'button.cancel': 'Annuleren',
  'button.save': 'Bewaar',
  'button.saving': 'Bewaar...',
  'page_role_create.form_name': 'Rolnaam',
  'button.submit': 'Verzenden',
  'button.back_to_log_in': 'Terug naar inloggen',
  'page_role_create.form_permissions': 'Machtigingen',
  'page_role_create.form_schema_min_name': 'Voer Rolnaam in',
  'page_role_create.form_schema_max_name':
    'Naam mag niet langer dan 256 tekens zijn.',
  'page_role_create.form_schema_claims':
    'Je moet minimaal één machtiging selecteren',
  'page_role_create.created_title_popup': 'Rol succesvol aangemaakt.',
  'page_role_show.roles_show_title': 'Portal Rol Bekijken',
  'page_role_show.info_card_title': 'Portal Rol Informatie',
  'page_role_show.users_card_title': 'Portal Rol Leden',
  'page_role_edit.roles_edit_title': 'Portal Rol Bewerken',
  'page_role_edit.updated_title_popup': 'Portal Rol succesvol bijgewerkt.',
  'account.verify.title': 'Email Geverifieerd',
  'account.verify_failed.title': 'Email Verificatie Mislukt',
  'account.verify.description':
    'Gefeliciteerd! Je hebt je email succesvol geverifieerd.',
  'account.verify.description_failed':
    '          De affiliate link is verlopen.',
  'account.verify-failed.title': 'Ongeldige Link',
  'account.verify-failed.description':
    'Deze link is niet meer geldig of is al gebruikt.',
  'account.verify-failed.description_sub':
    'Controleer opnieuw of neem contact op',
  'account.verify-failed.description_link': 'hier',
  'page_account_show.return_to_app.information': 'Terug naar app',
  'page_account_show.go_to_login.information': 'Naar inloggen',
  'page_account_show.back_to_login.information': 'Terug naar inloggen',
  'auth.login_session_expired': 'Je inlogsessie is verlopen',
  'page_log_overview.logs_title': 'Logs',
  'page_log_overview.id_log_title_table': 'ID',
  'page_log_overview.full_name_title_table': 'Uitgevoerd door',
  'page_log_overview.action_title_table': 'Acties',
  'page_log_overview.description_title_table': 'Beschrijving',
  'page_log_overview.form_created_at': 'Datum Tijd',
  'page_log_show.show_log_title': 'Log Bekijken',
  'page_log_show.info_card_title': 'Log Informatie',
  'page_my_profile.title': 'Mijn Account',
  'page_my_profile.description': 'Beheer je accountinformatie.',
  'page_my_profile.nav-information': 'Profiel',
  'page_my_profile.nav-password': 'Wachtwoord',
  'page_my_profile.nav-credit': 'Credit',
  'page_my_profile.form-title': 'Account Profiel',
  'page_my_profile.form-description': 'Zo zien anderen je op de site.',
  'page_my_profile.nav-notifications': 'Notificaties',
  'page_my_profile.nav-sub-notifications':
    'Beheer hoe en wanneer je notificaties ontvangt.',
  'page_my_profile.notifications.backup_emails_label':
    'Back-up van database-e-mails',
  'page_my_profile.notifications.backup_emails_description':
    'Ontvang notificaties over geplande en voltooide databaseback-ups.',
  'page_my_profile.notifications.contact_emails_label': 'Contact e-mails',
  'page_my_profile.notifications.contact_emails_description':
    'Ontvang e-mails wanneer iemand contact met je opneemt via het platform.',
  'page_my_profile.notifications.report_emails_label': 'Rapportage e-mails',
  'page_my_profile.notifications.report_emails_description':
    'Ontvang e-mails over rapporten, signalen en gerelateerde updates.',
  'page_my_profile.notifications.vacancy_emails_label': 'Vacature e-mails',
  'page_my_profile.notifications.vacancy_emails_description':
    'Ontvang e-mails over vacatures, sollicitaties en updates.',
  'page_my_profile.notifications.profile_title_popup':
    'Meldingen succesvol bijgewerkt.',
  'permissions_group.system': 'Systeem',
  'permissions_group.user': 'Klanten',
  'permissions_group.role': 'Rollen',
  'permissions_group.audit-log': 'Logs',
  'permissions_group.admin-user': 'Admins',
  'permissions_group.promotion': 'Vacature Configuraties',
  'permissions_group.review': 'Reviews',
  'permissions_group.profile_avatar': "Profielfoto's",
  'permissions.SUPER': 'Alle Machtigingen',
  'permissions.VIEW_DASHBOARD': 'Dashboard Bekijken',
  'permissions.VIEW_USER': 'Klant Bekijken',
  'permissions.CREATE_USER': 'Klant Aanmaken',
  'permissions.UPDATE_USER': 'Klant Bewerken',
  'permissions.DELETE_USER': 'Klant Verwijderen',
  'permissions.VIEW_ADMIN_USER': 'Admins Bekijken',
  'permissions.CREATE_ADMIN_USER': 'Admins Aanmaken',
  'permissions.UPDATE_ADMIN_USER': 'Admins Bewerken',
  'permissions.DELETE_ADMIN_USER': 'Admins Verwijderen',
  'permissions.VIEW_ROLE': 'Rol Bekijken',
  'permissions.CREATE_ROLE': 'Rol Aanmaken',
  'permissions.UPDATE_ROLE': 'Rol Bewerken',
  'permissions.DELETE_ROLE': 'Rol Verwijderen',
  'permissions.VIEW_AUDIT_LOG': 'Log Bekijken',
  'permissions.VIEW_PAGE': 'Pagina Bekijken',
  'permissions.CREATE_PAGE': 'Pagina Aanmaken',
  'permissions.UPDATE_PAGE': 'Pagina Bijwerken',
  'permissions.DELETE_PAGE': 'Pagina Verwijderen',
  'permissions.VIEW_CATEGORY': 'Categorie Bekijken',
  'permissions.CREATE_CATEGORY': 'Categorie Aanmaken',
  'permissions.UPDATE_CATEGORY': 'Categorie Bijwerken',
  'permissions.DELETE_CATEGORY': 'Categorie Verwijderen',
  'permissions.VIEW_AUTHOR': 'Auteur Bekijken',
  'permissions.CREATE_AUTHOR': 'Auteur Aanmaken',
  'permissions.UPDATE_AUTHOR': 'Auteur Bijwerken',
  'permissions.DELETE_AUTHOR': 'Auteur Verwijderen',
  'permissions.VIEW_PUBLISHER': 'Uitgever Bekijken',
  'permissions.CREATE_PUBLISHER': 'Uitgever Aanmaken',
  'permissions.UPDATE_PUBLISHER': 'Uitgever Bijwerken',
  'permissions.DELETE_PUBLISHER': 'Uitgever Verwijderen',
  'permissions.VIEW_PROMOTION': 'Promotie Bekijken',
  'permissions.CREATE_PROMOTION': 'Promotie Aanmaken',
  'permissions.UPDATE_PROMOTION': 'Promotie Bijwerken',
  'permissions.DELETE_PROMOTION': 'Promotie Verwijderen',
  'permissions.VIEW_REVIEW': 'Review Bekijken',
  'permissions.CREATE_REVIEW': 'Review Aanmaken',
  'permissions.UPDATE_REVIEW': 'Review Bijwerken',
  'permissions.DELETE_REVIEW': 'Review Verwijderen',
  'permissions.VIEW_SETTING': 'Instelling Bekijken',
  'permissions.UPDATE_SETTING': 'Instelling Aanmaken',
  'permissions.VIEW_MAIL_LOG': 'Mail Log Bekijken',
  'permissions.VIEW_SECURITY_ALERT': 'Beveiligingsmeldingen Bekijken',
  'permissions_group.page': "Pagina's",
  'permissions_group.author': 'Auteurs',
  'permissions_group.category': 'Categoriën',
  'permissions_group.tag': 'Tags',
  'permissions.VIEW_TAG': 'Tags Bekijken',
  'permissions.CREATE_TAG': 'Tags Aanmaken',
  'permissions.UPDATE_TAG': 'Tags Bewerken',
  'permissions.DELETE_TAG': 'Tags Verwijderen',
  'page_setting.title': 'Instellingen',
  'page_setting.report_export_toggle_label':
    'Handmatige rapportexport inschakelen',
  'page_setting.security_alert_section_title': 'Beveiligingswaarschuwing',
  'page_setting.security_alert_emails_label':
    'Ontvangers van beveiligingsmeldingen',
  'page_setting.security_alert_emails_placeholder':
    'security@example.com, alerts@example.com',
  'page_setting.security_alert_emails_tooltip':
    'Voer e-mailadressen in, gescheiden door komma’s.',
  'page_setting.security_alert_threshold_label':
    'Drempel voor verdachte activiteit',
  'page_setting.security_alert_threshold_tooltip':
    'Als dit leeg blijft, wordt de standaardwaarde 5 gebruikt.',
  'page_setting.security_alert_window_seconds_label': 'Tijdsvenster (seconden)',
  'page_setting.security_alert_window_seconds_tooltip':
    'Als dit leeg blijft, wordt de standaardwaarde 15 gebruikt.',
  'page_setting.customer_compliance_email_seconds':
    'Wachttijd voor het opnieuw verzenden van compliance-e-mails (seconden)',
  'page_setting.customer_compliance_email_seconds_tooltip':
    'Als dit leeg blijft, wordt de standaardwaarde 3600 gebruikt.',
  'menu.dashboards_title': 'Dashboards',
  'menu.management_title': 'Beheer',
  'menu.general_title': 'Algemeen',
  'menu.system_title': 'Systeem',
  'menu.logs_title': 'Logs',
  'menu.users_title': 'Klanten',
  'menu.setting_title': 'Instellingen',
  'menu.management_title.user': 'Klantenbeheer',
  'menu.management_title.user-configuration': 'Klantconfiguraties',
  'menu.management_title.user-nav-configurations': 'Configuraties',
  'menu.management_title.user-nav-gift-cards': 'Cadeaubonnen',
  'menu.email-log_title': 'E-mail Logs',
  'menu.security_alert_title': 'Beveiligingswaarschuwing',
  'menu.chatbot-log_title': 'Chatbot Logs',
  'menu.management_title.nav-views': 'Weergaven',
  'menu.management_title.nav-applies': 'Sollicitaties',
  'menu.management_title.company': 'Bedrijfsbeheer',
  'menu.management_title.job': 'Vacature Beheer',
  'page_admin_users_overview.title': 'Admins',
  'page_user_create.form_password': 'Wachtwoord',
  'page_user_create.confirm_password': 'Bevestig wachtwoord',
  'page_employee_overview.employee_title': 'Medewerkers',
  'option.yes': 'Ja',
  'option.no': 'Nee',
  'file_upload.file-invalid-type': 'Ongeldig bestandstype',
  'file_upload.file-too-large': 'Het geselecteerde bestand is te groot',
  'file_upload.file-too-small': 'Het geselecteerde bestand is te klein',
  'file_upload.too-many-files': 'Te veel bestanden geselecteerd',
  'status.active': 'Actief',
  'status.inactive': 'Inactief',
  'status.true': 'Geverifieerd',
  'status.false': 'Niet Geverifieerd',
  'breadcrumbs.management': 'Beheer',
  'breadcrumbs.management.jobs': 'Vacature Beheer',
  'breadcrumbs.general': 'Algemeen',
  'breadcrumbs.general.users': 'Systeem',
  'breadcrumbs.general.system': 'Systeem',
  'breadcrumbs.management.page': 'Pagina Beheer',
  'pages_management_setting.title': 'Pagina Configuraties',
  'pages_management_setting.toast_successful_title':
    'Paginaconfiguratie succesvol bijgewerkt.',
  'layout.goto': 'Ga naar klantenpagina',
  'user_management_setting.toast_successful_title':
    'Gebruikersconfiguraties succesvol bijgewerkt.',
  'chatbot.title': 'Chat met AI Jobs',
  'chatbot.button': 'Nieuwe Sessie',
  'error_toast.title': 'Er is iets misgegaan',
  'error_toast.description': 'Het probleem is gerapporteerd.',
  'error_toast.error_id': 'Fout ID: ',
  'common.time_minute': 'minuut',
  'common.time_second': 'seconde',
  'data_table.rows_selected': '{{count}} van {{total}} rij(en) geselecteerd',
  'data_table.total_items': 'Totaal {{count}} item(s)',
  'data_table.page_of': 'Pagina {{page}} van {{total}}',
  'data_table.no_results': 'Geen resultaten.',
  'data_table.unselect_all': 'Deselecteer alles',
  'validation.required': 'Dit veld is verplicht.',
  'validation.email.invalid': 'Ongeldig e-mailadres.',
  'validation.email.required': 'E-mailadres is verplicht.',
  'validation.password.required': 'Wachtwoord is verplicht.',
  'validation.password.matched': 'Wachtwoorden komen niet overeen.',
  'validation.password.min':
    'Wachtwoord moet minimaal {{ min }} tekens lang zijn',
  'validation.password.reset_token_invalid_title': 'Ongeldige of verlopen link',
  'validation.password.reset_token_invalid_description':
    'De link voor het opnieuw instellen van het wachtwoord is ongeldig of verlopen. Vraag een nieuwe aan.',
  'validation.iban.invalid': 'Ongeldig IBAN-nummer.',
  'validation.iban.required': 'IBAN-nummer is verplicht.',
  'validation.field.max': 'Maximale lengte is {{max}} tekens.',
  'validation.report_payment_import.file_required':
    'Upload een geldig CSV-bestand.',
  'validation.report_payment_import.file_type':
    'Alleen CSV-bestanden zijn toegestaan.',
  'validation.report_payment_import.file_max':
    'Het bestand mag maximaal {{max}} KB zijn.',
  'validation.report_payment_import.invalid_structure':
    'Het CSV-bestand heeft niet de verwachte structuur.',
  'page_dashboard.intro': 'Welkom in het Zeres-dashboard.',
  'page_stations_overview.title': 'Laadpaals',
  'button.reset': 'Resetten',
  'common.total_items': 'Totaal {{count}} item(s)',
  'common.create': 'Aanmaken',
  'common.save': 'Opslaan',
  'common.cancel': 'Annuleren',
  'common.close': 'Sluiten',
  'common.delete': 'Verwijderen',
  'common.edit': 'Bewerken',
  'common.view': 'Bekijken',
  'common.import': 'Importeren',
  'common.confirm': 'Bevestigen',
  'common.submit': 'Verzenden',
  'common.search': 'Zoeken',
  'common.search_placeholder': 'Zoeken...',
  'common.loading': 'Laden',
  'common.error': 'Fout',
  'common.success': 'Succes',
  'common.back': 'Terug',
  'common.next': 'Volgende',
  'common.previous': 'Vorige',
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.ok': 'OK',
  'common.action_irreversible': 'Deze actie is onomkeerbaar.',
  'common.are_you_sure': 'Weet je zeker dat je wilt {{action}}?',
  'common.version': 'Versie',
  'column.page_linked': 'Gekoppelde Pagina',
  'column.vacancy_title': 'Vacature Titel',
  'column.location': 'Locatie',
  'column.created_at': 'Aangemaakt Op',
  'column.last_updated_at': 'Laatst Bijgewerkt Op',
  'column.job_listing': 'Vacature Lijst',
  'column.note': 'Notitie',
  'column.errors': 'Fouten',
  'column.job_link': 'Vacature Link',
  'column.job_title': 'Vacature Titel',
  'column.status': 'Status',
  'column.code_id': 'Code ID',
  'column.message': 'Bericht',
  'column.id': 'ID',
  'column.category': 'Categorie',
  'column.company': 'Bedrijf',
  'column.type': 'Type',
  'column.actions': 'Acties',
  'column.updated_at': 'Bijgewerkt Op',
  'toast.created_successfully': 'Succesvol Aangemaakt',
  'toast.updated_successfully': 'Succesvol Bijgewerkt',
  'toast.deleted_successfully': 'Succesvol Verwijderd',
  'toast.imported_successfully': '{{count}} Vacature(s) Succesvol Geïmporteerd',
  'toast.error_submitted_successfully':
    'Fout verzonden voor coderegeneratie succesvol.',
  'tooltip.view_page': 'Pagina Bekijken',
  'tooltip.view_vacancy': 'Vacature Bekijken',
  'tooltip.view_job': 'Vacature Bekijken',
  'tooltip.edit_page': 'Pagina Bewerken',
  'tooltip.delete_page': 'Pagina Verwijderen',
  'tooltip.edit_error': 'Fout Bewerken',
  'tooltip.edit': 'Bewerken',
  'tooltip.delete': 'Verwijderen',
  'tooltip.not_have_permission': 'Je hebt niet de vereiste machtigingen',
  'tooltip.not_delete_role_admin': 'Deze rol kan niet worden verwijderd',
  'tooltip.not_edit_role_admin': 'Deze rol kan niet worden bewerkt',
  'form.not_available': 'Niet beschikbaar',
  'form.no_address': 'Geen Adres',
  'form.is_required': 'Dit veld is verplicht',
  'button.delete': 'Verwijderen',
  'button.coming_soon': 'Binnenkort Beschikbaar',
  'button.edit': 'Bewerken',
  'button.back': 'Terug',
  'button.upload': 'Uploaden',
  'button.analyse': 'Analyseren',
  'button.create': 'Aanmaken',
  'page_job_promotion.settings_title': 'Instellingen',
  'page_job_promotion.settings_website_title': 'Website Naam',
  'page_job_promotion.settings_website_meta_keywords':
    'Standaard Meta Trefwoorden',
  'page_job_promotion.settings_website_meta_description':
    'Standaard Meta Beschrijving',
  'page_job_promotion.settings_website_metadata': 'Website Metadata',
  'page_job_promotion.settings_website_logo': 'Logo (Licht)',
  'page_job_promotion.settings_website_logo_dark': 'Logo (Donker)',
  'page_job_promotion.settings_website_favicon': 'Favicon',
  'page_job_promotion.settings_save': 'Opslaan',
  'page_job_promotion.settings_updated':
    'Instellingen Bijgewerkt. Herlaad de pagina alstublieft',
  'page_job_promotion.settings_error_logo_upload':
    'Alleen PNG-bestanden zijn toegestaan.',
  'page_job_promotion.settings_error_favicon_upload':
    'Alleen PNG en ICO-bestanden zijn toegestaan.',
  'menu.management_title.page': 'Pagina Beheer',
  'menu.management_title.nav-page': "Pagina's",
  'menu.management_title.nav_blog': 'Berichten',
  'menu.management_title.nav_page_configuration': 'Pagina Configuraties',
  'page_dashboard.title': 'Dashboard',
  'page_dashboard.analytics': 'Analyses',
  'page_dashboard.total_published_jobs': 'Totaal Gepubliceerde Vacatures',
  'page_dashboard.total_job_views': 'Totaal Vacature Weergaven',
  'page_dashboard.total_users_sessions': 'Totaal Gebruikerssessies',
  'page_dashboard.live_presence_title': 'Admin aanwezigheid',
  'page_dashboard.live_presence_description':
    'Overzicht van de admins die momenteel actief zijn op Zeres.',
  'page_dashboard.online_count': 'Online admins',
  'page_dashboard.latest_online_users': 'Laatste online admins',
  'page_dashboard.online_now': 'Online',
  'page_dashboard.no_online_users': 'Er zijn momenteel geen admins online.',
  'page_dashboard.last_seen_at': 'Laatste activiteit',
  'page_dashboard.expires_at': 'Verloopt om',
  'page_dashboard.user_type_admin': 'Admin',
  'page_dashboard.user_type_customer': 'Klanten',
  'page_dashboard.user_type_all': 'Alle',
  'page_dashboard.customer_presence_title': 'Klanten aanwezigheid',
  'page_dashboard.customer_presence_description':
    'Overzicht van de klanten die momenteel actief zijn op Zeres.',
  'page_dashboard.customer_presence_online_count': 'Online klanten',
  'page_dashboard.latest_online_customers': 'Laatste online klanten',
  'page_dashboard.customer_presence_empty':
    'Klanten aanwezigheid is nog niet beschikbaar.',
  'page_dashboard.all_presence_title': 'Gebruikers aanwezigheid',
  'page_dashboard.all_presence_description':
    'Overzicht van de admins en klanten die momenteel actief zijn op Zeres.',
  'page_dashboard.latest_online_all_users': 'Laatste online gebruikers',
  'page_dashboard.all_presence_empty':
    'Er zijn momenteel geen gebruikers online.',
  'page_dashboard.total_jobs_applications': 'Totaal Vacature Sollicitaties',
  'page_dashboard.jobs_and_applications': 'Weergaven en Sollicitaties',
  'page_dashboard.recent_jobs_applications': 'Recente Vacature Sollicitaties',
  'page_dashboard.views_and_applications': 'Weergaven en Sollicitaties',
  'page_dashboard.recent_vacancies': 'Recente Vacatures',
  'page_dashboard.total_credits': 'Totaal Credits',
  'page_dashboard.total_jobs': 'Totaal Vacatures',
  'page_dashboard.total_views': 'Totaal Weergaven',
  'page_dashboard.total_applications': 'Totaal Sollicitaties',
  'page_dashboard.purchase_credits': 'Credits Kopen',
  'page_dashboard.a_user_session':
    'Een gebruikerssessie wordt geteld wanneer een gebruiker de AI JOBS website betreedt en de website 10 minuten gebruikt.',
  'page_dashboard.after_10_minutes':
    'Na 10 minuten, als een gebruiker terugkeert naar de website, wordt dit geteld als een nieuwe sessie.',
  'page_page_overview.title': "Pagina's",
  'page_page_overview.error_title': 'Vul minimaal één taal in (EN of NL)',
  'page_page_overview.delete_page_title_popup':
    'Weet je zeker dat je deze pagina wilt verwijderen?',
  'page_page_overview.delete_page_description_popup':
    'Deze actie is onomkeerbaar.',
  'page_page_overview.delete_page_successful_title_popup':
    'Pagina Succesvol Verwijderd',
  'page_page_create.create_page_title': 'Pagina Aanmaken',
  'page_page_create.create_page_information': 'Pagina Informatie',
  'page_page_create.create_status': 'Status',
  'page_page_create.seo_title': 'SEO Informatie',
  'page_page_create.seo_slug': 'Slug',
  'page_page_create.meta_keywords': 'Meta Trefwoorden',
  'page_page_create.meta_description': 'Meta Beschrijving',
  'page_page_create.created_title_popup': 'Pagina Succesvol Aangemaakt',
  'page_page_create.create_position': 'Positie',
  'page_page_create.create_order': 'Volgorde',
  'page_page_show.show_page_title': 'Pagina Bekijken',
  'page_page_show.information': 'Pagina Informatie',
  'page_page_show.id': 'ID',
  'page_page_show.status': 'Status',
  'page_page_show.type': 'Type',
  'page_page_show.slug': 'Slug',
  'page_page_show.title': 'Titel',
  'page_page_show.meta_description': 'Meta Beschrijving',
  'page_page_show.meta_keywords': 'Meta Trefwoorden',
  'page_page_show.seo_information': 'SEO Informatie',
  'page_page_show.content': 'Pagina Inhoud',
  'page_page_show.content_label': 'Inhoud',
  'page_page_show.headline': 'Kop',
  'page_page_show.position': 'Positie',
  'page_page_show.order': 'Volgorde',
  'page_page_show.template': 'Template',
  'page_page_show.featured_image': 'Uitgelichte Afbeelding',
  'page_page_edit.edit_page_title': 'Pagina Bewerken',
  'page_page_edit.page_information': 'Pagina Informatie',
  'page_page_edit.edot_page_status': 'Status',
  'page_page_edit.seo_title': 'SEO Informatie',
  'page_page_edit.seo_slug': 'Slug',
  'page_page_edit.meta_keywords': 'Meta Trefwoorden',
  'page_page_edit.meta_description': 'Meta Beschrijving',
  'page_page_edit.edit_title_popup': 'Pagina Succesvol Bijgewerkt',
  'page_page_edit.edit_status': 'Status',
  'page_page_edit.edit_position': 'Positie',
  'page_page_edit.edit_order': 'Volgorde',
  'page_page_edit.page_type': 'Type',
  'page_page_edit.page_template': 'Template',
  'page_page_edit.featured_image': 'Uitgelichte Afbeelding',
  'page_map.longitude': 'Lengtegraad',
  'page_map.latitude': 'Breedtegraad',
  'page_map.zoom': 'Zoom',
  'page_map.id': 'ID',
  'page_map.type': 'Type',
  'page_map.category': 'Categorie',
  'page_map.requirements': 'Vacature Beschrijving',
  'page_map.company_title': 'Bedrijfsinformatie',
  'page_map.company_name': 'Bedrijfsnaam',
  'page_map.company_website': 'Website van het bedrijf',
  'page_map.contact_phone': 'Contact telefoon',
  'page_map.contact_email': 'Contact email',
  'page_map.contact_name': 'Contact naam',
  'page_map.general_info': 'Algemene info',
  'page_map.button_apply': 'Solliciteren',
  'page_map.search_city_placeholder': 'Zoeken op plaatsnaam',
  'page_map.search_job_placeholder': 'Zoeken op vacaturenaam',
  'page_map.reset_filter': 'Alle filters wissen',
  'page_map.city': 'Plaats',
  'page_map.select_job_type_placeholder': 'Vacature Types',
  'page_map.select_job_categories_placeholder': 'Vacature Categorieën',
  'page_map.job_address': 'Bedrijfsadres',
  'page_map.address': 'Adres',
  'page_blog_overview.title': 'Berichten',
  'page_blog_overview.error_title': 'Vul minimaal één taal in (EN of NL)',
  'page_blog_overview.delete_page_title_popup':
    'Weet je zeker dat je dit bericht wilt verwijderen?',
  'page_blog_overview.delete_page_description_popup':
    'Deze actie is onomkeerbaar.',
  'page_blog_overview.delete_page_successful_title_popup':
    'Bericht Succesvol Verwijderd',
  'page_blog_overview.id': 'ID',
  'page_blog_overview.name_en': 'Naam (EN)',
  'page_blog_overview.name_nl': 'Naam (NL)',
  'page_blog_overview.slug': 'Slug',
  'page_blog_overview.position': 'Positie',
  'page_blog_overview.order': 'Volgorde',
  'page_blog_overview.status': 'Status',
  'page_blog_overview.actions': 'Acties',
  'page_blog_create.create_page_title': 'Bericht Aanmaken',
  'page_blog_create.create_page_information': 'Bericht Informatie',
  'page_blog_create.create_status': 'Status',
  'page_blog_create.seo_title': 'SEO Informatie',
  'page_blog_create.seo_slug': 'Slug',
  'page_blog_create.meta_keywords': 'Meta Trefwoorden',
  'page_blog_create.meta_description': 'Meta Beschrijving',
  'page_blog_create.created_title_popup': 'Bericht Succesvol Aangemaakt',
  'page_blog_show.show_page_title': 'Bericht Bekijken',
  'page_blog_show.information': 'Bericht Informatie',
  'page_blog_show.id': 'ID',
  'page_blog_show.status': 'Status',
  'page_blog_show.slug': 'Slug',
  'page_blog_show.title': 'Titel',
  'page_blog_show.meta_description': 'Meta Beschrijving',
  'page_blog_show.meta_keywords': 'Meta Trefwoorden',
  'page_blog_show.seo_information': 'SEO Informatie',
  'page_blog_show.content': 'Bericht Inhoud',
  'page_blog_show.content_label': 'Inhoud',
  'page_blog_show.headline': 'Kop',
  'page_blog_show.template': 'Template',
  'page_blog_show.featured_image': 'Uitgelichte Afbeelding',
  'page_blog_edit.edit_page_title': 'Bericht Bewerken',
  'page_blog_edit.page_information': 'Bericht Informatie',
  'page_blog_edit.edot_page_status': 'Status',
  'page_blog_edit.seo_title': 'SEO Informatie',
  'page_blog_edit.seo_slug': 'Slug',
  'page_blog_edit.meta_keywords': 'Meta Trefwoorden',
  'page_blog_edit.meta_description': 'Meta Beschrijving',
  'page_blog_edit.edit_title_popup': 'Bericht Succesvol Bijgewerkt',
  'page_blog_edit.edit_status': 'Status',
  'page_blog_edit.page_template': 'Template',
  'page_blog_edit.featured_image': 'Uitgelichte Afbeelding',
  'page_email_logs.title': 'E-mail Logs',
  'page_email_logs.id': 'ID',
  'page_email_logs.subject': 'Onderwerp',
  'page_email_logs.to': 'Aan',
  'page_email_logs.status': 'Status',
  'page_email_logs.created_at': 'Verzonden op',
  'page_security_alert.title': 'Beveiligingsmeldingen',
  'page_security_alert.id': 'ID',
  'page_security_alert.event_type': 'Gebeurtenistype',
  'page_security_alert.email': 'E-mail',
  'page_security_alert.ip_address': 'IP-adres',
  'page_security_alert.user_agent': 'Gebruikersagent',
  'page_security_alert.route': 'API-eindpunt',
  'page_security_alert.method': 'Methode',
  'page_security_alert.created_at': 'Aangemaakt op',
  'page_security_alert.event_types.permission_denied': 'Geen toegang',
  'page_security_alert.event_types.brute_force_detected':
    'Brute-force gedetecteerd',
  'page_mail_log.title': 'E-maillog',
  'page_mail_log.card_title': 'Informatie E-maillog',
  'page_mail_log.id': 'ID',
  'page_mail_log.sender': 'Afzender',
  'page_mail_log.subject': 'Onderwerp',
  'page_mail_log.receiver': 'Aan',
  'page_mail_log.status': 'Status',
  'page_mail_log.created_at': 'Verzonden op',
  'page_mail_log.message': 'Bericht',
  'page_mail_log.content': 'E-mailinhoud',
  'page_mail_log.status.sent': 'Verzonden',
  'page_mail_log.status.failed': 'Mislukt',
  'page_page_overview.id': 'ID',
  'page_page_overview.name_en': 'Naam (EN)',
  'page_page_overview.name_nl': 'Naam (NL)',
  'page_page_overview.slug': 'Slug',
  'page_page_overview.position': 'Positie',
  'page_page_overview.order': 'Volgorde',
  'page_page_overview.status': 'Status',
  'page_page_overview.actions': 'Acties',
  'page_role_overview.id': 'ID',
  'page_role_overview.actions': 'Acties',
  'page_role_show.id': 'Gebruikers ID',
  'page_role_show.full_name': 'Volledige Naam',
  'page_role_show.email': 'Email',
  'page_role_show.actions': 'Acties',
  'page_admin_user_overview.title': 'Admin Gebruikers',
  'page_admin_user_overview.id': 'ID',
  'page_admin_user_overview.full_name': 'Volledige Naam',
  'page_admin_user_overview.email': 'Email',
  'page_admin_user_overview.role': 'Rol',
  'page_admin_user_overview.actions': 'Acties',
  'page_customer_job_listing.id': 'ID',
  'page_customer_job_listing.name': 'Naam',
  'page_customer_job_listing.address': 'Adres',
  'page_customer_job_listing.expired_date': 'Vervaldatum',
  'page_customer_job_listing.status': 'Status',
  'page_customer_job_listing.type': 'Type',
  'page_customer_job_listing.category': 'Categorie',
  'page_customer_job_listing.salary': 'Salaris',
  'page_customer_job_listing.updated_by': 'Bijgewerkt Door',
  'page_customer_job_listing.applications': 'Sollicitaties',
  'page_customer_job_listing.views': 'Weergaven',
  'page_customer_job_listing.actions': 'Acties',
  'page_transaction_columns.id': 'ID',
  'page_transaction_columns.customer': 'Klanten',
  'page_transaction_columns.payment_date': 'Betaaldatum',
  'page_transaction_columns.reference_id': 'Referentie ID',
  'page_transaction_columns.type': 'Type',
  'page_transaction_columns.amount': 'Bedrag',
  'page_transaction_columns.discount_amount': 'Kortingsbedrag',
  'page_transaction_columns.promo_code': 'Promotiecode',
  'page_transaction_columns.status': 'Status',
  'page_transaction_columns.actions': 'Acties',
  'page_audit_logs.title': 'Audit Logs',
  'page_audit_logs.id': 'ID',
  'page_audit_logs.causer_name': 'Uitgevoerd door',
  'page_audit_logs.event': 'Gebeurtenis',
  'page_audit_logs.description': 'Beschrijving',
  'page_audit_logs.created_at': 'Aangemaakt Op',
  'page_audit_logs.actions': 'Acties',
  'Customer self-registration': 'Zelfregistratie klant',
  'System process': 'Systeemproces',
  'page_my_profile.form_first_name': 'Voornaam',
  'page_my_profile.form_first_name_placeholder': 'Voornaam',
  'page_my_profile.form_last_name': 'Achternaam',
  'page_my_profile.form_last_name_placeholder': 'Achternaam',
  'page_my_profile.form_email': 'Email',
  'page_my_profile.form_email_placeholder': 'test@example.com',
  'page_my_profile.form_phone_number': 'Telefoonnummer',
  'page_my_profile.form_phone_number_placeholder': 'Telefoonnummer',
  'page_my_profile.form_language': 'Weergavetaal',
  'page_my_profile.select_language': 'Selecteer taal',
  'page_customer_profile.select_customer_language': 'Selecteer klanttaal',
  'page_company_edit.general_information': 'Algemene Informatie',
  'page_company_edit.career_page': 'Carrière Pagina',
  'page_company_edit.extra_information': 'Extra Informatie',
  'page_company_edit.company_address': 'Bedrijfsadres',
  'page_company_edit.enter_company_address': 'Voer Bedrijfsadres in',
  'page_company_edit.find_location': 'Locatie Vinden',
  'page_company_edit.address_description':
    'Voer het adres van je bedrijf in en klik vervolgens op "Locatie Vinden" om de locatie van je bedrijf bij te werken.',
  'page_login.portal_label': 'Beheerdersportaal',
  'page_login.title': 'Inloggen',
  'page_login.description': 'Voer je email en wachtwoord in om in te loggen',
  'page_login.email_label': 'Email',
  'page_login.email_placeholder': 'naam@example.com',
  'page_login.password_label': 'Wachtwoord',
  'page_login.password_placeholder': '********',
  'page_login.captcha_label': 'Captcha',
  'page_login.captcha_placeholder': 'Voer de captcha in',
  'page_login.captcha_refresh': 'Vernieuwen',
  'page_login.captcha_required': 'Vul de captcha in.',
  'page_login.captcha_loading': 'Captcha laden...',
  'page_login.captcha_load_failed':
    'Captcha laden mislukt. Probeer het opnieuw.',
  'page_login.security_load_failed':
    'Loginbeveiliging laden mislukt. Probeer het opnieuw.',
  'page_login.sign_in': 'Inloggen',
  'page_login.forgot_password_link': 'Ik ben mijn wachtwoord vergeten',
  'page_forgot_password.title': 'Wachtwoord Vergeten',
  'page_forgot_password.description':
    'Voer je email in om je wachtwoord te resetten',
  'page_forgot_password.email_label': 'Email',
  'page_forgot_password.email_placeholder': 'naam@example.com',
  'page_forgot_password.toast_title':
    'Je verzoek om het wachtwoord te resetten is succesvol verzonden.',
  'page_forgot_password.toast_description':
    'Controleer je email voor verdere instructies.',
  'page_job_create.all_required': '(Alle * is verplicht)',
  'page_job_create.level_label': 'Niveau',
  'page_job_create.level_placeholder': 'Voer functieniveau in',
  'page_job_create.job_description': 'Functiebeschrijving',
  'page_job_create.address_information': 'Adresinformatie',
  'page_job_create.address_line_1': 'Adresregel 1',
  'page_job_create.address_line_2': 'Adresregel 2',
  'page_job_create.city_country': 'Plaats - Land',
  'page_job_create.state_province_region': 'Provincie/Regio',
  'page_job_create.zip_postal_code': 'Postcode',
  'page_job_create.find_location': 'Locatie Vinden',
  'page_job_create.latitude': 'Breedtegraad',
  'page_job_create.enter_latitude': 'Voer breedtegraad in',
  'page_job_create.latitude_description': 'Breedtegraad (van -90 tot 90)',
  'page_job_create.longitude': 'Lengtegraad',
  'page_job_create.enter_longitude': 'Voer lengtegraad in',
  'page_job_create.longitude_description': 'Lengtegraad (van -180 tot 180)',
  'page_job_create.auto_generate': 'Laat leeg om automatisch te genereren',
  'page_login_customer.customer_portal': 'Klantenportaal',
  'page_login_customer.enter_credentials':
    'Voer je e-mail en wachtwoord in om in te loggen',
  'page_login_customer.email': 'E-mail',
  'page_login_customer.email_placeholder': 'email@example.com',
  'page_login_customer.password': 'Wachtwoord',
  'page_login_customer.password_placeholder': '********',
  'page_login_customer.sign_in': 'Inloggen',
  'page_login_customer.or': 'OF',
  'page_login_customer.sign_in_google': 'Inloggen met Google',
  'page_login_customer.no_account': 'Heb je geen account?',
  'page_login_customer.sign_up_now': 'Nu registreren!',
  'page_login_customer.background_alt': 'Achtergrond klantportaal',
  'page_login_customer.logo_alt': 'Zeres-logo',
  'page_login_customer.forgot_description':
    'Voer je e-mailadres in om een resetcode te ontvangen',
  'page_login_customer.reset_description':
    'Voer de resetcode in en stel je nieuwe wachtwoord in',
  'page_login_customer.forgot_password': 'Wachtwoord vergeten',
  'page_login_customer.send_reset_code': 'Resetcode verzenden',
  'page_login_customer.back_to_sign_in': 'Terug naar inloggen',
  'page_login_customer.reset_code': 'Resetcode',
  'page_login_customer.reset_code_placeholder': 'Voer resetcode in',
  'page_login_customer.new_password_placeholder': 'Voer nieuw wachtwoord in',
  'page_login_customer.confirm_password': 'Bevestig wachtwoord',
  'page_login_customer.confirm_password_placeholder':
    'Bevestig nieuw wachtwoord',
  'page_login_customer.reset_password_button': 'Wachtwoord resetten',
  'page_login_customer.validation_invalid_email': 'Ongeldig e-mailadres',
  'page_login_customer.validation_reset_code_required':
    'Resetcode is verplicht',
  'page_login_customer.validation_password_min':
    'Wachtwoord moet minimaal 8 tekens bevatten',
  'page_login_customer.validation_confirm_password_required':
    'Bevestig je wachtwoord',
  'page_login_customer.validation_passwords_not_match':
    'Wachtwoorden komen niet overeen',
  'page_register_successful.title': 'Registratie succesvol!',
  'page_register_successful.verification_sent':
    'Er is een verificatie-e-mail verzonden naar je geregistreerde e-mailadres. Volg de instructies in de e-mail om je account te verifiëren.',
  'page_register_successful.check_spam':
    'Als je de e-mail niet ziet, controleer dan je spamfolder of neem contact met ons op',
  'page_register_successful.here': 'hier',
  'page_register_successful.back_to_login': 'Terug naar inloggen',
  'page_register.customer_portal': 'Klantenportaal',
  'page_register.create_account': 'Maak je account aan om te beginnen',
  'page_register.sign_up_google': 'Registreren met Google',
  'page_register.or': 'OF',
  'page_register.first_name': 'Voornaam',
  'page_register.last_name': 'Achternaam',
  'page_register.email': 'E-mail',
  'page_register.password': 'Wachtwoord',
  'page_register.confirmation_password': 'Bevestig wachtwoord',
  'page_register.display_language': 'Weergavetaal',
  'page_register.select_language': 'Selecteer taal',
  'page_register.registering': 'Registreren...',
  'page_register.register': 'Registreren',
  'page_register.already_account': 'Heb je al een account?',
  'page_register.sign_in': 'Inloggen',
  'password_validation.min_length': 'Minimaal 8 tekens',
  'password_validation.has_number': 'Minimaal 1 cijfer',
  'password_validation.has_lowercase': 'Minimaal 1 kleine letter',
  'password_validation.has_uppercase': 'Minimaal 1 hoofdletter',
  'password_validation.has_special': 'Minimaal 1 speciaal teken',
  'page_customer_job_show.unpublish_job_success':
    'Vacature(s) succesvol gedepubliceerd.',
  'page_customer_job_show.publish_job_success':
    'Vacature(s) succesvol gepubliceerd.',
  'page_customer_job_show.unpublish_confirmation':
    'Deze actie zal de huidige vacature depubliceren naar het systeem',
  'page_customer_job_show.publish_confirmation_title':
    'Weet je zeker dat je de vacature wilt publiceren?',
  'page_customer_job_show.publish_description':
    'Na publicatie, als vacature(s) een locatie hebben, wordt dit weergegeven op de kaart.',
  'page_customer_job_show.publish': 'Publiceren',
  'page_customer_job_show.level': 'Niveau',
  'page_customer_job_show.applications': 'Sollicitaties',
  'page_customer_job_show.views': 'Weergaven',
  'page_customer_job_show.address_information': 'Adresinformatie',
  'page_customer_job_show.city': 'Plaats',
  'page_customer_job_show.job_address': 'Vacature Adres',
  'page_customer_job_show.state_province_region': 'Provincie/Regio',
  'page_customer_job_show.zip_postal_code': 'Postcode',
  'page_customer_job_show.latitude': 'Breedtegraad',
  'page_customer_job_show.longitude': 'Lengtegraad',
  'page_customer_overview.delete_button': 'Alles verwijderen',
  'page_customer_overview.delete_all_success_title':
    'Alle klanten zijn succesvol verwijderd.',
  'page_customer_overview.delete_all_title': 'Alle klanten verwijderen',
  'page_customer_overview.delete_all_description':
    'Weet je zeker dat je alle klanten wilt verwijderen? Deze actie zal alle klanten, laadpalen en rapporten van alle klanten verwijderen.',
  'page_setting.logo_tooltip':
    'Het logo moet in PNG- of WEBP-formaat zijn en mag niet groter zijn dan 1 MB.',
  'page_setting.favicon_tooltip':
    'De favicon moet in PNG-, ICO- of WEBP-formaat zijn en mag niet groter zijn dan 500 kB.',
  'page_setting.report_compensation_percentage_label':
    'Rapport compensatiepercentage (%)',
  'page_setting.zeres_commission_label': 'Zeres commissie',
  'breadcrumbs.management.users': 'Klanten Beheer',
  'table.id': 'ID',
  'table.brand': 'Merk',
  'table.model': 'Model',
  'table.evse_id': 'Serienummer',
  'table.start_date': 'Startdatum',
  'table.end_date': 'Einddatum',
  'table.total_kwh': 'Totaal kWh',
  'table.actions': 'Acties',
  'table.customer': 'Klanten',
  'page_reports_overview.created_at': 'Rapport datum',
  'page_reports_overview.start_date': 'Begindatum',
  'page_reports_overview.end_date': 'Einddatum',
  'page_reports_overview.compensation': 'Opbrengst',
  'page_customer_create.phone_number': 'Telefoonnummer',
  'page_user_create.extra_information_title': 'Extra informatie',
  'page_user_create.zeres_commission': 'Zeres commissie',
  'page_user_create.customer_discount_percentage': 'Klantkortingspercentage',
  'page_user_create.partner_discount_code': 'Partner kortingscode',
  'page_user_create.estimated_yearly_kwh': 'Geschat jaarlijks kWh',
  'page_user_create.partner_percentage': 'Partnerpercentage',
  'page_customer_create.mid_control': 'Controle',
  'page_customer_create.control_performed_at': 'Controle uitgevoerd op',
  'page_customer_create.control_performed_by': 'Controle uitgevoerd door',
  'page_user_show.extra_information_title': 'Extra informatie',
  'page_customer_overview.id': 'ID',
  'page_customer_overview.connect_id': 'Verbindings-ID',
  'page_customer_overview.full_name': 'Volledige Naam',
  'page_customer_overview.email': 'Email',
  'page_customer_overview.station_brand_model': 'Merk / Model',
  'page_customer_overview.station_evse_id': 'Serienummer',
  'page_customer_overview.control': 'Controle',
  'page_customer_overview.partnercode': 'Partner Code',
  'page_customer_overview.registered_date': 'Registratiedatum',
  'page_customer_overview.account_status': 'Account Status',
  'page_customer_overview.company': 'Bedrijf',
  'page_customer_overview.external_user': 'Externe Gebruiker',
  'page_customer_overview.actions': 'Acties',
  'page_customer_overview.stations_title': 'Laadpalen',
  'page_customer_overview.import_button': 'Klanten importeren',
  'page_customer_overview.import_dialog_title': 'Klanten importeren',
  'page_customer_overview.last_login': 'Laatste login',
  'page_customer_overview.total_volume_all_stations_kwh':
    'Totaal volume alle laadpalen',
  'page_customer_overview.import_dialog_description':
    'Upload een CSV-bestand om klanten te importeren.',
  'page_customer_overview.import_choose_file': 'Bestand kiezen',
  'page_customer_overview.import_no_file_selected': 'Geen bestand geselecteerd',
  'page_customer_overview.import_max_file_size':
    'Maximale bestandsgrootte: 5MB.',
  'page_customer_overview.import_invalid_file':
    'Het CSV-bestand heeft niet de verwachte structuur voor klantenimport.',
  'page_customer_overview.import_sample_file_helper':
    'Heb je een voorbeeldbestand nodig?',
  'page_customer_overview.import_sample_file_download':
    'Download voorbeeldbestand',
  'page_customer_overview.import_submit_button': 'Importeren',
  'page_customer_overview.import_success_title': 'Importverzoek geaccepteerd',
  'page_customer_overview.import_success_description':
    'Het klantimportverzoek is geaccepteerd.',
  'page_customer_overview.import_warning_title': 'Import niet beschikbaar',
  'page_customer_overview.import_warning_in_progress':
    'De klantimport is al bezig. Wacht tot deze is voltooid. Je kunt de voortgang volgen in Importlog.',
  'page_customer_overview.import_warning_cooldown':
    'De klantimport is zojuist voltooid. Wacht nog {{ remaining_time }} voordat je een nieuwe import start.',
  'page_customer_overview.export_button': 'Klanten exporteren',
  'page_customer_overview.export_warning_title': 'Export niet beschikbaar',
  'page_customer_overview.export_warning_in_progress':
    'De klantenexport is al bezig. Wacht tot deze is voltooid.',
  'page_customer_overview.export_warning_cooldown':
    'De klantenexport is zojuist voltooid. Wacht nog {{ remaining_time }} voordat je een nieuwe export start.',
  'page_customer_overview.export_success_title': 'Het exportproces is gestart',
  'page_customer_overview.export_success_description':
    'Ga naar de pagina Klanten exportlog om de voortgang te bekijken en het bestand te downloaden zodra het klaar is.',
  'page_customer_overview.is_compliant': 'Compliant',
  'page_customer_overview.not_compliant': 'Niet compliant',
  'page_customer_overview.iban_number': 'Bankrekeningnummer',
  'page_customer_overview.ean_number': 'EAN nummer',
  'page_customer_overview.account_holder_name': 'Rekeninghouder',
  'page_customer_overview.send_compliance_mails_successful_title':
    'Emails verzonden',
  'page_reports_show.total_kwh': 'Totaal volume kWh',
  'page_reports_show.total_volume_kwh': 'Totaal volume kWh',
  'page_report_show.calculated_eres': "Berekende ERE'S",
  'page_report_show.booked_eres': "Ingeboekt aantal ERE'S",
  'page_report_show.revenue': 'Opbrengst',
  'page_report_show.payment': 'Betalingen',
  'page_report_show.general_information': 'Algemene informatie',
  'page_report_show.station': 'Laadpaal',
  'page_report_show.name': 'Naam',
  'page_report_show.address': 'Adres',
  'page_report_show.phone_number': 'Telefoonnummer',
  'page_report_show.ean_18_number': 'EAN-18 nummer',
  'page_report_show.account_holder_name': 'Naam van de rekeninghouder',
  'page_report_show.iban_number': 'IBAN-nummer',
  'page_report_show.connect_id': 'Verbindings-ID',
  'page_report_show.comments': 'Opmerkingen',
  'page_report_show.photos': 'Geüploade documenten',
  'page_report_show.discard_changes_title': 'Wijzigingen verwerpen?',
  'page_report_show.discard_changes_description':
    'U heeft niet-opgeslagen wijzigingen in deze laadpaal. Wilt u deze verwerpen?',
  'page_report_show.discard': 'Verwerpen',
  'page_customer_create.street': 'Straat',
  'page_customer_create.house_number': 'Huisnummer',
  'page_customer_create.post_code': 'Postcode',
  'page_customer_create.place': 'Plaats',
  'page_customer_create.documentation': 'Documentatie',
  'page_customer_create.account_holder_name': 'Naam rekeninghouder',
  'page_customer_create.ean_number': 'EAN Nummer',
  'page_customer_create.comments': 'Opmerkingen',
  'page_stations_overview.button.create': 'Aanmaken',
  'page_stations_overview.delete_station_title_popup':
    'Weet u zeker dat u dit laadpaal wilt verwijderen?',
  'page_stations_overview.delete_station_description_popup':
    'Deze actie kan niet ongedaan worden gemaakt.',
  'page_stations_overview.delete_station_successful_title_popup':
    'Station is verwijderd.',
  'page_stations_show.title': 'Laadpaal details',
  'page_stations_show.customer': 'Klant',
  'page_stations_show.brand': 'Merk',
  'page_stations_show.model': 'Model',
  'page_stations_show.evse_id': 'Serienummer',
  'page_stations_show.start_date': 'Startdatum',
  'page_stations_show.end_date': 'Einddatum',
  'page_stations_show.start_kwh': 'Start (kWh)',
  'page_stations_show.end_kwh': 'Eind (kWh)',
  'page_stations_show.total_kwh': 'Geladen kWh',
  'page_stations_show.mid_status': 'MID meter',
  'page_stations_show.mid_id': 'MID ID',
  'page_station_brand_ranking.title': 'Merkdetails',
  'page_station_brand_ranking.description': 'Laadpalen gegroepeerd per merk.',
  'page_station_brand_ranking.email': 'E-mail',
  'page_station_brand_ranking.model': 'Model',
  'page_station_brand_ranking.evse_id': 'Serienummer',
  'page_station_brand_ranking.total_kwh': 'Geladen kWh',
  'page_station_brand_ranking.missing_brand': 'Merk ontbreekt.',
  'page_station_brand_ranking.open_customer_detail': 'Open klanten detail',
  'page_stations_show.registration_date': 'Opnamedatum',
  'page_stations_show.created_at': 'Aangemaakt op',
  'page_stations_show.updated_at': 'Bijgewerkt op',
  'page_stations_show.button.delete': 'Verwijderen',
  'page_stations_show.button.back': 'Terug',
  'page_stations_show.button.edit': 'Bewerken',
  'page_stations_edit.title': 'Laadpaal bewerken',
  'page_stations_edit.customer': 'Klant',
  'page_stations_edit.brand': 'Merk',
  'page_stations_edit.model': 'Model',
  'page_stations_edit.evse_id': 'Serienummer',
  'page_stations_edit.start_date': 'Startdatum',
  'page_stations_edit.end_date': 'Einddatum',
  'page_stations_edit.start_kwh': 'Start (kWh)',
  'page_stations_edit.end_kwh': 'Eind (kWh)',
  'page_stations_edit.total_kwh': 'Geladen kWh',
  'page_stations_edit.created_at': 'Aangemaakt op',
  'page_stations_edit.updated_at': 'Bijgewerkt op',
  'page_stations_edit.button.save': 'Opslaan',
  'page_stations_edit.information_alert':
    'Voer het totale volume direct in (hieronder in het veld “Geladen kWh”) of voer hieronder de meterstanden in (met datum en meterwaarde).',
  'page_stations_edit.warning_alert':
    'Het totale volume ({{ total }} kWh) komt niet overeen met de meterstanden ({{ calculated }} kWh).',
  'page_stations_create.title': 'Laadpaal aanmaken',
  'page_stations_create.customer': 'Klanten',
  'page_stations_create.brand': 'Merk',
  'page_stations_create.model': 'Model',
  'page_stations_create.evse_id': 'Serienummer',
  'page_stations_create.start_date': 'Startdatum',
  'page_stations_create.end_date': 'Einddatum',
  'page_stations_create.start_kwh': 'Start (kWh)',
  'page_stations_create.end_kwh': 'Eind (kWh)',
  'page_stations_create.total_kwh': 'Totaal (kWh)',
  'page_stations_create.created_at': 'Aangemaakt op',
  'page_stations_create.updated_at': 'Bijgewerkt op',
  'page_stations_create.button.save': 'Opslaan',
  'page_stations_create.information_alert':
    'Voer het totale volume direct in (hieronder in het veld “Geladen kWh”) of voer hieronder de meterstanden in (met datum en meterwaarde).',
  'page_stations_create.warning_alert':
    'Het totale volume ({{ total }} kWh) komt niet overeen met de meterstanden ({{ calculated }} kWh).',
  'page_stations_create.created_title_popup': 'Laadpaal is aangemaakt.',
  'page_stations_create.no_customer_id': 'Klant ID is verplicht.',
  'page_reports_overview.export_queued_success':
    'Genereerverzoek is succesvol in de wachtrij geplaatst.',
  'page_reports_overview.export_queued_failed':
    'Het plaatsen van het genereerverzoek in de wachtrij is mislukt.',
  'page_reports_overview.generate_warning_title': 'Genereren niet beschikbaar',
  'page_reports_overview.generate_warning_in_progress':
    'De rapportgeneratie is al bezig. Wacht tot deze is voltooid.',
  'page_reports_overview.generate_warning_cooldown':
    'De rapportgeneratie is zojuist voltooid. Wacht nog {{ remaining_time }} voordat je een nieuwe generatie start.',
  'page_reports_overview.export_reports_queued_success':
    'Exportverzoek is succesvol in de wachtrij geplaatst.',
  'page_reports_overview.export_reports_queued_failed':
    'Het plaatsen van het exportverzoek in de wachtrij is mislukt.',
  'page_reports_overview.export_reports_success_title':
    'Het exportproces is gestart',
  'page_reports_overview.export_reports_success_description':
    'Ga naar de pagina Exportlog om de voortgang te bekijken en het bestand te downloaden zodra het klaar is.',
  'page_reports_overview.export_reports_warning_title':
    'Export niet beschikbaar',
  'page_reports_overview.export_reports_warning_in_progress':
    'De rapportexport is al bezig. Wacht tot deze is voltooid. Je kunt de voortgang bekijken in Exportlog.',
  'page_reports_overview.export_reports_warning_cooldown':
    'De rapportexport is zojuist voltooid. Wacht nog {{ remaining_time }} voordat je een nieuwe export start. Je kunt de laatste voortgang bekijken in Exportlog.',
  'page_reports_overview.import_payments_button': 'Betalingen importeren',
  'page_reports_overview.import_payments_title': 'Import betalingen',
  'page_reports_overview.import_payments_description':
    'Upload een CSV-bestand met de kolommen Klant ID, Rapport ID, Volume, Ingeboekt, Opbrengst, Betaling en Betaaldatum.',
  'page_reports_overview.import_payments_submit': 'Importeren',
  'page_reports_overview.import_payments_helper':
    'Alleen CSV-bestanden met exact de verwachte kolommen worden geaccepteerd.',
  'page_reports_overview.import_payments_choose_file': 'Bestand kiezen',
  'page_reports_overview.import_payments_no_file_selected':
    'Geen bestand geselecteerd',
  'page_reports_overview.import_payments_required':
    'Selecteer eerst een CSV-bestand om te importeren.',
  'page_reports_overview.import_payments_invalid_file':
    'Het CSV-bestand heeft niet de verwachte structuur.',
  'page_reports_overview.import_payments_success_title':
    'Betalingsimport is gestart',
  'page_reports_overview.import_payments_success_description':
    'Het bestand is in de wachtrij geplaatst voor verwerking. Je kunt de voortgang volgen in Importlog.',
  'page_reports_overview.import_payments_queued_message':
    'Het bestand is in de wachtrij geplaatst voor verwerking. Je kunt de voortgang volgen in Importlog.',
  'page_reports_overview.import_payments_warning_title':
    'Import niet beschikbaar',
  'page_reports_overview.import_payments_warning_in_progress':
    'De betalingsimport is al bezig. Wacht tot deze is voltooid. Je kunt de voortgang volgen in Importlog.',
  'page_reports_overview.import_payments_warning_cooldown':
    'De betalingsimport is zojuist voltooid. Wacht nog {{ remaining_time }} voordat je een nieuwe import start. Je kunt de laatste voortgang volgen in Importlog.',
  'page_history_overview.title': 'Importlog',
  'page_history.button.back': 'Terug',
  'page_history.button.delete': 'Verwijderen',
  'page_history_overview.id': 'ID',
  'page_history_overview.file_process': 'Bestand verwerken',
  'page_history_overview.type': 'Type',
  'page_history_overview.type_customer': 'Klanten',
  'page_history_overview.type_mid': 'MID',
  'page_history_overview.type_payment': 'Betalingen',
  'page_history_overview.total_items': 'Totaal aantal items',
  'page_history_overview.proceed_items': 'Verwerkte items',
  'page_history_overview.created_clients': 'Klanten aangemaakt',
  'page_history_overview.created_at': 'Aangemaakt op',
  'page_history_item.title': 'Importlog detail',
  'page_history_item.row_number': 'Rijnummer in XLS',
  'page_history_item.email': 'E-mail',
  'page_history_item.metadata': 'Metadata',
  'page_history_item.metadata_compensation': 'Opbrengst',
  'page_history_item.metadata_payment': 'Betalingen',
  'page_history_item.metadata_payment_date': 'Betaaldatum',
  'page_history_item.status': 'Status',
  'page_history_item.failed_reason': 'Reden mislukt',
  'page_customer_export_history.title': 'Exportlog',
  'page_customer_export_history.id': 'ID',
  'page_customer_export_history.type': 'Type',
  'page_customer_export_history.type_customer': 'Klanten',
  'page_customer_export_history.type_report': 'Rapporten',
  'page_customer_export_history.exported_by': 'Door',
  'page_customer_export_history.file_path': 'Bestandspad',
  'page_customer_export_history.total_items': 'Totaal klanten',
  'page_customer_export_history.proceed_items': 'Verwerkte klanten',
  'page_customer_export_history.status': 'Status',
  'page_customer_export_history.status_in_progress': 'Bezig',
  'page_customer_export_history.status_failed': 'Mislukt',
  'page_customer_export_history.status_completed': 'Voltooid',
  'page_customer_export_history.process': 'Voortgang',
  'page_customer_export_history.actions': 'Acties',
  'page_customer_export_history.download': 'Downloaden',
  'page_customer_export_history.deleted_success':
    'Exportlog succesvol verwijderd.',
  'page_customer_overview.mid_status': 'MID meter aanwezig',
  'page_customer_export_history.delete_title_popup':
    'Weet je zeker dat je deze exportlog wilt verwijderen?',
  'page_customer_export_history.delete_description_popup':
    'Dit verwijdert het logrecord en het opgeslagen exportbestand permanent.',
  'page_customer_export_history.created_at': 'Aangemaakt op',
  'page_history.title': 'Importlog',
  'page_history_overview.process': 'Voortgangs - percentage',
  'My account': 'Mijn account',
  'Manage your details and charging stations':
    'Beheer uw gegevens en laadpalen',
  'My details': 'Mijn gegevens',
  'My charging stations': 'Mijn laadpalen',
  Reports: 'Rapporten',
  Logout: 'Uitloggen',
  account: 'account',
  'Invalid IBAN number': 'Ongeldig IBAN-nummer',
  'Check the IBAN number': 'Controleer het IBAN-nummer',
  'Save failed, please try again.': 'Opslaan mislukt, probeer het opnieuw.',
  'Document uploaded': 'Document geupload',
  'Document upload failed': 'Document upload mislukt',
  'Document deleted': 'Document verwijderd',
  'Deleting document failed': 'Document verwijderen mislukt',
  'Invalid EAN-18 number':
    'Ongeldig EAN-18 nummer. Het moet met 871 beginnen en uit 18 cijfers bestaan.',
  'Check the EAN-18 number': 'Controleer het EAN-18 nummer',
  'File is larger than 10MB': 'is groter dan 10MB',
  'Maximum 5 files allowed': 'Maximaal 5 bestanden toegestaan',
  'Uploading...': 'Uploaden...',
  'Click to select files': 'Klik om bestanden te selecteren',
  Saved: 'Opgeslagen',
  Ok: 'Ok',
  'First name': 'Voornaam',
  'Last name': 'Achternaam',
  Street: 'Straat',
  'House number': 'Huisnummer',
  'Postal code': 'Postcode',
  City: 'Plaats',
  'Phone number': 'Telefoonnummer',
  'EAN-18 number': 'EAN-18 nummer',
  'Account holder name': 'Naam rekeninghouder',
  'IBAN number': 'IBAN-nummer',
  'Connect Id': 'Verbindings-ID',
  'Zeres commission': 'Commissie Zeres',
  'Discount code': 'Kortingscode van een partner',
  Notes: 'Opmerkingen',
  'Max 1500 characters': 'Maximaal 1500 tekens',
  Documents: 'Documenten',
  Save: 'Opslaan',
  'Saving...': 'Opslaan...',
  'The EAN-18 number is a unique identification number for your electricity connection. You can find it on your energy bill or contract. It starts with 871 and consists of 18 digits.':
    'Het EAN-18 nummer (ook wel EAN-code) is een uniek identificatienummer voor uw elektriciteitsaansluiting. U vindt dit nummer op uw energierekening of contract. Het begint met 871 en bestaat uit 18 cijfers.',
  'The changes have been saved.': 'Uw gegevens zijn opgeslagen.',
  'The charging station and its data have been removed.':
    'De laadpaal en zijn gegevens zijn verwijderd.',
  'Add charging station': 'Laadpaal toevoegen',
  'No charging stations added yet. Click on "+ Add charging station" to start.':
    'Nog geen laadpalen toegevoegd. Klik op "+ Laadpaal toevoegen" om te beginnen.',
  'Charging station': 'Laadpaal',
  Brand: 'Merk',
  Model: 'Model',
  'page_charging_stations.evse_id': 'Serienummer',
  'See the manual for instructions on finding the serial number.':
    'Zie de handleiding voor instructies voor het vinden van het serienummer van uw laadpaal.',
  'Connect your charger to our platform if not already connected.':
    'Verbind uw laadpaal met ons platform zodat wij automatisch kunnen uitlezen.',
  'Connect charging station to the Zeres platform':
    'Laadpaal verbinden met het Zeres-platform',
  'Connect charging station to the Zeres platform...':
    'Laadpaal verbinden met het Zeres-platform...',
  'An example of a serial number is': 'Een voorbeeld van een serienummer is',
  'Enter the total volume of this charging station for this quarter.':
    'Voer het totaal volume van deze laadpaal voor dit kwartaal in.',
  'Enter the total number of kilowatt-hours (kWh) charged for this period.':
    "Vul uw kWh in vanaf 1 januari tot vandaag, minus de kWh's die eerder dit jaar zijn geregistreerd. Kijk hiervoor onder de tab Rapporten.",
  'Enter the total number of kilowatt-hours (kWh) charged for this quarter and the recording date. You can find the total number of kilowatt-hours charged in your charging station app or in a report. If you do not have this data but have recorded the meter reading for this quarter, enter the difference between the start and end readings.':
    'Geef het totaal aantal geladen kilowattuur (kWh) voor dit kwartaal en de opnamedatum op. Het totaal aantal geladen kilowattuur kun je vinden in de app van jouw laadpaal of in een rapportage. Als je deze gegevens niet hebt maar wel de meterstand voor dit kwartaal hebt opgenomen, vul dan het verschil tussen de begin- en eindstand in.',
  'Charging stations help label charged kwh': 'Geladen stroom kWh:',
  'Charging stations help value charged kwh':
    'U heeft tot 15 dagen na kwartaaleinde om uw laadstroom op te geven.',
  'Charging stations help label connection': 'Laadpaal verbinden:',
  'Charging stations help value connection':
    'U kunt uw laadpaal met ons platform verbinden zodat wij deze kunnen uitlezen. De merken waarvoor dit kan, staan onder Mijn laadpalen: Laadpaal verbinden.',
  'Charging stations help label period': 'Welke periode:',
  'Charging stations help value period':
    'Vanaf de vorige opnamedatum of vanaf 1 januari 2026 als er geen eerdere opgave is gedaan.',
  'Charging stations help label proof': 'Bewijs:',
  'Charging stations help value proof':
    'U kunt rapportages of screenshots uploaden in de portal.',
  'Charging stations help label payment': 'Uitbetaling:',
  'Charging stations help value payment':
    "Na controle en inboeking bij de NEa ziet u de status van uw ERE's onder Rapporten. De uitbetaling volgt ongeveer 3 weken na inboeking bij de NEa.",
  'Start date': 'Begindatum',
  'Start reading (kWh)': 'Beginstand (kWh)',
  'End date': 'Einddatum',
  'End reading (kWh)': 'Eindstand (kWh)',
  'Charged kWh': 'Geladen kWh',
  Since: 'sinds',
  'Total volume (kWh)': 'Geladen kWh',
  'Total volume of all charging stations (kWh)':
    'Totaal volume alle laadpalen (kWh)',
  'Calculated number of EREs': 'Berekend aantal EREs',
  Notification: 'Kennisgeving',
  'Charging station removed': 'Laadpaal verwijderd',
  'Charging stations saved!': 'Laadpaal informatie opgeslagen',
  'Saving failed. Please try again.': 'Opslaan mislukt. Probeer opnieuw.',
  'You can add a maximum of 3 charging stations.':
    'U kunt maximaal 3 Laadpaals toevoegen.',
  'The total volume': 'Het Totaal volume',
  'is not equal to the meter readings': 'is ongelijk aan de meterstanden',
  'is not equal to the sum of the charging stations':
    'is ongelijk aan de som van de Laadpaals',
  'Total volume': 'Totaal volume',
  EREs: "ERE's",
  'ERE revenue': 'ERE-opbrengst',
  'General information': 'Algemene informatie',
  Name: 'Naam',
  Address: 'Adres',
  Comments: 'Opmerkingen',
  'Uploaded photos': 'Geüploade documenten',
  'Charging station (brand, model, ID)': 'Laadpaal (merk, model, ID)',
  'Start date and reading': 'Begindatum en stand',
  'End date and reading': 'Einddatum en stand',
  'No reports available yet.': 'Er zijn nog geen rapporten beschikbaar.',
  Period: 'Periode',
  'Earn money with every charging session': 'Verdien geld bij elke laadsessie',
  'Receive a fee for every kWh charged through your charging point. Sustainable and profitable.':
    'Ontvang een vergoeding voor elke kWh die via uw laadpunt wordt geladen. Duurzaam én rendabel.',
  'Delete charging station': 'Laadpaal verwijderen',
  'Are you sure you want to delete this charging station? This action cannot be undone.':
    'Weet u zeker dat u deze laadpaal wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  Cancel: 'Annuleren',
  Delete: 'Verwijderen',
  'Loading quarterly reports...': 'Laden van rapporten...',
  'Failed to load quarterly reports.': 'Rapporten laden mislukt.',
  'Loading charging stations...': 'Laden van laadpalen...',
  'Failed to load charging stations.': 'Laadpalen laden mislukt.',
  'The EAN-18 number (also called EAN code) is a unique identification number for your electricity connection. You can find it on your energy bill or contract. It starts with 871 and consists of 18 digits.':
    'Het EAN-18 nummer (ook wel EAN-code) is een uniek identificatienummer voor uw elektriciteitsaansluiting. U vindt dit nummer op uw energierekening of contract. Het begint met 871 en bestaat uit 18 cijfers.',
  'Delete Document': 'Document verwijderen',
  'Are you sure you want to delete this document? This action cannot be undone.':
    'Weet u zeker dat u dit document wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'If you have received a discount code from one of our partners, please enter it here.':
    'Als je een kortingscode van één van onze partners hebt ontvangen, vul die dan hier in.',
  'The account number consists of 18 letters and numbers and begins with the country code. In the Netherlands, this is NL.':
    'Het rekeningnummer bestaat uit 18 letters en cijfers en begint met de landcode. In Nederland is dat NL.',
  'Registration date': 'Opnamedatum',
  optional: 'optioneel',
  'The email has already been taken': 'De email is al in gebruik',
  'validation.password.number':
    'Het wachtwoord moet minimaal 1 cijfer bevatten',
  'validation.password.letter':
    'Het wachtwoord moet minimaal 1 letter bevatten',
  document: 'handleiding',
  "Enter the volume of charging current for the entire period: you can see this, among other places, in your charging station's App or on a report. You can also enter the difference between a start and end reading":
    'Vul het volume aan laadstroom van de hele periode in: dit ziet u o.a. in de App van uw laadpaal of op een rapportage. U kunt ook het verschil tussen een begin- en eindstand invoeren.',

  'page_tags_overview.title': 'Tags',
  'page_tags_overview.created_at': 'Aangemaakt op',
  'page_tags_overview.updated_at': 'Bijgewerkt op',
  'page_tags_overview.button.delete': 'Verwijderen',
  'page_tags_overview.button.back': 'Terug',
  'page_tags_overview.button.edit': 'Bewerken',

  'page_tags_edit.title': 'Tag bewerken',
  'page_tags_edit.created_at': 'Aangemaakt op',
  'page_tags_edit.updated_at': 'Bijgewerkt op',
  'page_tags_edit.button.save': 'Opslaan',

  'page_tags_create.title': 'Tag aanmaken',
  'page_tags_create.created_at': 'Aangemaakt op',
  'page_tags_create.updated_at': 'Bijgewerkt op',
  'page_tags_create.button.save': 'Opslaan',
  'page_tags_update.title': 'Tag bijwerken',

  'page_tags_overview.name': 'Naam',
  'page_tags_overview.delete_title_popup':
    'Weet u zeker dat u deze tag wilt verwijderen?',
  'page_tags_overview.delete_description_popup':
    'Deze actie kan niet ongedaan worden gemaakt.',
  'page_tag_overview.toast_successful_description':
    'Tag is succesvol verwijderd.',
  'page_tag_overview.helper_text_tooltip':
    "Druk op Tab of Enter om nieuwe tags toe te voegen. U kunt ook meerdere tags aanmaken met puntkomma's.",
  'No results': 'Geen resultaten',
  'Searching...': 'Zoeken...',
  'tooltip.max_stations': 'Maximale 3 laadpalen',
  'page_dashboard.registered_customers_title': 'Geregistreerde klanten',
  'page_dashboard.registered_customers_description':
    'Nieuwe klantregistraties binnen de geselecteerde periode.',
  'page_dashboard.total_registered_customers':
    'Totaal geregistreerde klanten all time',
  'page_dashboard.new_registered_customers': 'Nieuwe geregistreerde klanten:',
  'page_dashboard.registered_customers_footer_day':
    'Geregistreerde klanten per uur',
  'page_dashboard.registered_customers_footer_week_month':
    'Geregistreerde klanten per dag',
  'page_dashboard.charging_station_brands_title': 'Top laadpalen',
  'page_dashboard.charging_station_brands_description':
    'Live ranglijst van laadpalen op basis van het huidige totaal kWh zoals opgeteld per Laadpaal merk.',
  'page_dashboard.charging_station_brands_empty': 'Geen laadpalen gevonden.',
  'page_dashboard.charging_station_brands_footer':
    'Toont de top laadpalen op basis van het huidige totaal kWh.',
  'page_dashboard.analytics_title': 'Online Gebruikers Monitor',
  'page_dashboard.analytics_description':
    'De gegevens worden elke 5 minuten bijgewerkt. Herlaad de grafiek om de nieuwste waarden te zien.',
  'page_dashboard.analytics_footer': 'Online gebruikers per uur',
  'page_dashboard.loading_chart': 'Grafiek laden...',
  'page_dashboard.reload_analytics': 'Grafiek herladen',
  'page_dashboard.select_date': 'Selecteer datum',
  'page_dashboard.online_users_series': 'Online gebruikers:',
  'page_dashboard.time_mode': 'Tijdmodus',
  'page_dashboard.time_mode_day': 'Dag',
  'page_dashboard.time_mode_week': 'Week',
  'page_dashboard.time_mode_month': 'Maand',
  'page_dashboard.time_mode_year': 'Jaar',
  'page_dashboard.analytics_footer_day': 'Online gebruikers per uur',
  'page_dashboard.analytics_footer_week_month': 'Online gebruikers per dag',
  'page_dashboard.view_brand_details': 'Bekijk merkdetails',

  'page_mid_overview.title': 'MID meter info',
  'page_mids_overview.title': 'MID meter info',
  'page_mid_overview.created_at': 'Aangemaakt op',
  'page_mid_overview.updated_at': 'Bijgewerkt op',
  'page_mid_overview.id': 'ID',
  'page_mid_overview.brand': 'Merk',
  'page_mid_overview.model': 'Model',
  'page_mid_overview.status': 'MID meter',
  'page_mid_overview.source_text': 'Bron',
  'page_mid_overview.explanation_text': 'Uitleg',
  'page_mid_overview.import_button': 'Importeren',
  'page_mid_overview.import_dialog_title': 'MID importeren',
  'page_mid_overview.import_dialog_description':
    'Selecteer een CSV bestand om MIDs te importeren.',
  'page_mid_overview.import_max_file_size':
    'Maximaal toegestane bestandsgrootte: 5 MB',
  'page_mid_overview.import_choose_file': 'Bestand kiezen',
  'page_mid_overview.import_no_file_selected': 'Geen bestand geselecteerd',
  'page_mid_overview.import_invalid_file':
    'Fout bij het importeren van het CSV-bestand. Er ontbreekt een kopregel om de kolommen aan te geven. Voeg de volgende kopregel toe en zorg ervoor dat de kolommen in deze volgorde staan: Merk, Model, Status, Uitleg, Bron.',
  'page_mid_overview.import_success_title': 'MID import is gestart',
  'page_mid_overview.import_warning_in_progress': 'De MID import is al bezig.',
  'page_mid_overview.import_warning_cooldown': 'Er is al een MID import bezig.',
  'page_mid_overview.import_warning_title': 'Waarschuwing',
  'page_mid_overview.import_logic_title': 'Importlogica:',

  'page_mid_overview.import_logic_existing':
    'Als Merk en Model al bestaan, worden de MID-status, Bron en Uitleg bijgewerkt.',

  'page_mid_overview.import_logic_new':
    'Als Merk en Model nog niet bestaan, wordt een nieuwe regel toegevoegd. Bestaande regels worden niet verwijderd.',

  'page_mid_overview.import_logic_matching':
    'Hoofdletters en spaties aan het begin of einde worden genegeerd. Kleine verschillen in Merk of Model worden als een nieuwe combinatie beschouwd.',

  'page_mid_overview.import_logic_stations':
    'Bestaande laadpalen van klanten worden niet automatisch bijgewerkt. De MID-status verandert pas wanneer de laadpaal opnieuw wordt opgeslagen.',

  'page_mids_edit.edit_mid_title': 'MID meter info bewerken',
  'page_mids_edit.edit_title_popup': 'MID is succesvol bijgewerkt.',

  'page_mids_create.title': 'MID meter info aanmaken',
  'page_mids_create.brand': 'Merk',
  'page_mids_create.model': 'Model',
  'page_mids_create.status': 'Status',
  'page_mids_create.source_text': 'Bron',
  'page_mids_create.explanation_text': 'Uitleg',
  'page_mids_create.created_title_popup': 'MID is succesvol aangemaakt.',

  'page_mids_show.title': 'Laadpaal MID details',
  'page_mids_show.card_title': 'Laadpaal MID details',
  'page_mids_show.brand': 'Merk',
  'page_mids_show.model': 'Model',
  'page_mids_show.status': 'Status',
  'page_mids_show.source_text': 'Bron',
  'page_mids_show.explanation_text': 'Uitleg',
  'page_mids_overview.delete_mid_title_popup':
    'Weet u zeker dat u deze MID wilt verwijderen?',
  'page_mids_overview.delete_mid_description_popup':
    'Dit is een permanente actie.',

  'status.NO': 'Nee',
  'status.YES': 'Ja',
  'status.MAYBE': 'Misschien',
  'status.UNKNOWN': 'Onbekend',

  'button.close': 'Sluiten',
  'button.issues': 'Probleen',
  'button.send': 'Verzenden',
  'button.sending': 'Verzenden...',
  'popup.to': 'Naar',
  'popup.subject': 'Onderwerp',
  'popup.message': 'Bericht',

  'Manually approved compliance': 'Handmatig goedgekeurd compliance',
  'Update MID Meter Presentation': 'MID meter presentatie bijwerken',
  'This action will update the MID meter present field for {{count}} selected charging stations.':
    'Dit actie zal de MID meter presentatie veld bijwerken voor {{count}} geselecteerde laadpalen.',
  'page_customer_overview.toast_successful_title':
    'MID-meterstatus succesvol bijgewerkt voor de geselecteerde laadpalen.',
  'page_customer_overview.bulk_update_button': 'MID-meter in bulk bijwerken',

  'page_customer_show.compliance_status': 'Compliant'
}
